module.exports = "<itpx-navbar></itpx-navbar>\n<simple-notifications [options]=\"options\">\n</simple-notifications>\n<div class=\"global-loader-container\">\n    <div class=\"container\">\n        <itpx-alert></itpx-alert>\n        <router-outlet (activate)=\"onActivate($event)\"></router-outlet>\n    </div>\n    <itpx-loader *ngIf=\"(loading | async)?.loading\"></itpx-loader>\n    <itpx-footer [hidden]=\"((loading | async)?.loading)\"></itpx-footer>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main